<template>
  <div class="recycle-price_wrapper">
    <div class="header-banner">
      <div class="header-overlay">
        <p class="header-overlay_title">再生资源回收价格指数</p>
        <p class="subtitle">实时追踪可再生资源市场价格变动</p>
      </div>
    </div>
    <div class="recycle-price-index">
      <template v-if="!showCard">
        <div class="filter-bar">
          <!--          <el-select-->
          <!--            v-model="selectedCategory"-->
          <!--            placeholder="所有分类"-->
          <!--            clearable-->
          <!--          >-->
          <!--            <el-option-->
          <!--              v-for="category in categories"-->
          <!--              :key="category.id"-->
          <!--              :label="category.categoryName"-->
          <!--              :value="category.id"-->
          <!--            ></el-option>-->
          <!--          </el-select>-->
          <el-input
            v-model="searchQuery"
            placeholder="搜索资源名称..."
            prefix-icon="el-icon-search"
            clearable
          ></el-input>
        </div>
        <div class="waste-buttons-container">
          <div class="filter-title">筛选：</div>
          <el-select
            class="smallScreen"
            v-model="selectedCategory"
            placeholder="全部"
          >
            <el-option
              v-for="category in categories"
              :key="category.id"
              :label="category.categoryName"
              :value="category.id"
            ></el-option>
          </el-select>
          <p
            v-for="category in categories"
            :key="category.id"
            class="waste-button"
            :class="[
              category.id == selectedCategory ? 'waste-button_active' : '',
            ]"
            @click.stop="selectedCategory = category.id"
          >
            {{ category.categoryName }}
          </p>
        </div>
        <div class="resource-grid" v-if="filteredResources.length">
          <el-card
            v-for="resource in filteredResources"
            :key="resource.id"
            class="resource-card"
            shadow="hover"
            @click.native="goToDetail(resource.id)"
          >
            <div class="card-header">
              <div
                class="resource-icon"
                :style="{ backgroundColor: resource.color }"
              >
                <i :class="resource.icon"></i>
              </div>
              <div class="resource-name">{{ resource.name }}</div>
            </div>
            <div class="price-section">
              <div class="current-price">
                ¥{{ resource.price }}{{ resource.unit }}
              </div>
              <div class="price-change">
                <!-- <div class="change-item">
                  <span>同比</span>
                  <span :class="getChangeClass(resource.yoy)">
                    {{ formatChange(resource.yoy) }}
                  </span>
                </div> -->
                <div class="change-item">
                  <span>环比</span>
                  <span :class="getChangeClass(resource.mom)">
                    {{ formatChange(resource.mom) }}
                  </span>
                </div>
              </div>
            </div>
            <div class="trend-chart">
              <mini-trend-chart
                :data="resource.trendData"
                :width="chartSize.width"
                :height="chartSize.height"
                :color="resource.color"
              ></mini-trend-chart>
            </div>
            <div class="update-time">最新: {{ resource.updateTime }}</div>
          </el-card>
        </div>
        <el-empty
          v-else
          :image="require('@/assets/recycling/index/empty.svg')"
          description="暂无数据"
        />
      </template>
      <card-info
        @goBack="showCard = false"
        :wasteSubId="currentSubId"
        :baseTypeData="baseTypeData"
        v-else
      />
    </div>
    <bottom-url />
  </div>
</template>

<script>
import MiniTrendChart from './component/MiniTrendChart.vue';
import cardInfo from '@/views/PriceIndex/component/cardInfo.vue';
import bottomUrl from '@/components/bottomUrl/bottomUrl.vue';
import { scrollTop } from '@/util/scrollTop';
import {
  getWasteTypeAll,
  getWasteSubList,
  getAllCategoryTrend,
} from '@/API/price/price.js';
import fecha from 'element-ui/src/utils/date';
import { cloneDeep } from 'lodash';

export default {
  components: {
    MiniTrendChart,
    cardInfo,
    bottomUrl,
  },
  data() {
    return {
      baseTypeData: {}, // 卡片基本信息
      currentSubId: 3, // 展示卡片的子类id
      showCard: false,
      selectedCategory: 0,
      searchQuery: '',
      categories: [], // 所有大类
      resources: [],
      chartSize: {
        width: 320,
        height: 100,
      },
    };
  },
  async created() {
    await this.getWasteTypeList();
    getAllCategoryTrend().then((res) => {
      if (res.code == 200) {
        let tempArr = [];
        this.resources = [];
        let iconObj = [
          {
            icon: 'el-icon-cpu',
            color: '#FF6B6B',
          },
          {
            icon: 'el-icon-connection',
            color: '#FFA502',
          },
          {
            icon: 'el-icon-magic-stick',
            color: '#7BED9F',
          },
          {
            icon: 'el-icon-milk-tea',
            color: '#70A1FF',
          },
          {
            icon: 'el-icon-bangzhu',
            color: '#ee6b00',
          },
          {
            icon: 'el-icon-pie-chart',
            color: '#7b2de8',
          },
          {
            icon: 'el-icon-mouse',
            color: '#2de7d5',
          },
          {
            icon: 'el-icon-receiving',
            color: '#e63b6f',
          },
          {
            icon: 'el-icon-money',
            color: '#e265c5',
          },
          {
            icon: 'el-icon-cpu',
            color: '#878f7d',
          },
        ];
        if (res.data && res.data.length) {
          // let index = res.data.length - 10;
          // let startIndex = Math.max(index, 0);
          // let tempRes = res.data.slice(startIndex);
          // 过滤未激活的类型
          let tempRes = res.data.filter((item) =>
            this.categories.find((cg) => cg.id == item.categoryId),
          );
          console.log('235326263643', tempRes, this.categories);

          tempRes.forEach((item) => {
            let obj = {
              id: item.id,
              name: item.wasteName,
              mom: item.growthRatio,
              categoryId: item.categoryId,
              description: item.description,
              categoryName: item.categoryName,
              originTrendData: item.trendData,
              trendDescription: item.trendDescription,
            };
            if (item.trendData && item.trendData.length) {
              let dataArr = [];
              item.trendData.forEach((d, index) => {
                if (index == item.trendData.length - 1) {
                  obj.price = d.price;
                  obj.updateTime = fecha.format(
                    new Date(d.priceDate),
                    'yyyy-MM-dd',
                  );
                  obj.unit = item.unit;
                }
                dataArr.push(d.price);
              });
              obj.trendData = dataArr;
            }
            let findIndex = 0;
            this.categories.forEach((cg, index) => {
              if (cg.id == item.categoryId) {
                findIndex = index;
              }
            });
            tempArr.push({ ...obj, ...iconObj[findIndex] });
          });
          let resList = [];
          this.categories.forEach((cg) => {
            tempArr.forEach((item) => {
              if (item.categoryId == cg.id) {
                resList.push(item);
              }
            });
          });
          this.resources = resList;
        }
      }
      console.log('所有子类11111', res, this.resources);
    });
  },
  watch: {
    '$store.state.routerClickStatus': {
      handler: function (value) {
        this.moveHome();
      },
    },
  },
  computed: {
    currentDate() {
      return new Date().toLocaleDateString('zh-CN', {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
      });
    },
    filteredResources() {
      let result = this.resources;
      if (this.selectedCategory) {
        result = result.filter(
          (item) => item.categoryId === this.selectedCategory,
        );
      }
      if (this.selectedCategory == 0) {
        result = this.resources;
      }
      if (this.searchQuery) {
        const query = this.searchQuery.toLowerCase();
        result = result.filter((item) =>
          item.name.toLowerCase().includes(query),
        );
      }
      console.log('筛选后的资源', result);
      return result;
    },
  },
  mounted() {
    const toValue = decodeURIComponent(
      (window.location.hash.match(/to=([^&]*)/) || [])[1] || null,
    );
    console.log(toValue);
    // 初始化时设置一次
    this.setChartSize();
    // 监听窗口大小变化
    window.addEventListener('resize', this.setChartSize);
    
    // 新增：检查是否有从全局搜索跳转过来的关键词
    const globalKeyword = sessionStorage.getItem('search_keyword_from_global');
    if (globalKeyword) {
      this.searchQuery = globalKeyword;
      sessionStorage.removeItem('search_keyword_from_global');
    }
  },
  beforeDestroy() {
    // 销毁组件时移除监听，避免内存泄漏
    window.removeEventListener('resize', this.setChartSize);
  },
  methods: {
    setChartSize() {
      const windowWidth = window.innerWidth;
      // 根据屏幕宽度设置不同的宽高
      if (windowWidth >= 1200) {
        this.chartSize = { width: 320, height: 70 };
      } else if (windowWidth >= 768) {
        this.chartSize = { width: 320, height: 70 };
      } else {
        // 移动端宽度设为容器100%（也可以设固定值）
        this.chartSize = { width: 210, height: 100 };
      }
    },
    getChangeClass(change) {
      return change >= 0 ? 'negative' : 'positive';
    },
    formatChange(change) {
      return change >= 0
        ? `↑ ${change.toFixed(2)}%`
        : `↓ ${Math.abs(change).toFixed(2)}%`;
    },
    goToDetail(id) {
      // if (id == 1) {
      this.showCard = true;
      this.currentSubId = id;
      let serchRes = this.resources.find((item) => item.id == id);
      this.baseTypeData = cloneDeep(serchRes);
      console.log('aeghgdshrd', serchRes, id, this.currentSubId);
      // } else {
      //   this.$message.error('该类型暂无数据');
      // }
    },
    moveHome() {
      this.showCard = false;
      scrollTop();
    },
    // 获取所有废品大类
    async getWasteTypeList() {
      let res = await getWasteTypeAll();
      this.categories = [{ categoryName: '全部', id: 0 }];
      if (res.code == 200) {
        if (res.data && res.data && res.data.length) {
          this.categories.push(...res.data);
        }
        console.log('所有分类', this.categories);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.recycle-price-index {
  max-width: 1200px;
  margin: 0 auto 50px auto;
  padding: 20px;

  .header {
    text-align: center;
    margin-bottom: 30px;

    h1 {
      font-size: 32px;
      color: #2c3e50;
      margin-bottom: 10px;
    }

    .subtitle {
      font-size: 16px;
      color: #7f8c8d;
      margin-bottom: 20px;
    }

    .stats-summary {
      display: flex;
      justify-content: center;
      gap: 30px;
      background: #f8f9fa;
      padding: 15px;
      border-radius: 10px;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);

      .stat-item {
        display: flex;
        flex-direction: column;
        align-items: center;

        .stat-label {
          font-size: 14px;
          color: #7f8c8d;
          margin-bottom: 5px;
        }

        .stat-value {
          font-size: 24px;
          font-weight: bold;
          color: #2c3e50;
        }

        .stat-change {
          font-size: 14px;
          font-weight: bold;

          &.positive {
            color: #2ecc71;
          }

          &.negative {
            color: #e74c3c;
          }
        }

        .stat-date {
          font-size: 14px;
          color: #2c3e50;
        }
      }
    }
  }

  .filter-bar {
    display: flex;
    gap: 15px;
    margin-bottom: 20px;

    .el-select {
      width: 180px;
    }

    .el-input {
      flex: 1;
    }
  }

  .resource-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
    gap: 20px;
  }

  .resource-card {
    border-radius: 12px;
    transition: transform 0.3s;
    cursor: pointer;

    &:hover {
      transform: translateY(-5px);
    }

    .card-header {
      display: flex;
      align-items: center;
      margin-bottom: 15px;

      .resource-icon {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-right: 15px;
        color: white;
        font-size: 20px;
      }

      .resource-name {
        max-width: calc(100% - 55px);
        font-size: 20px;
        font-weight: bold;
        color: #2c3e50;
      }
    }

    .price-section {
      margin-bottom: 15px;

      .current-price {
        font-size: 22px;
        font-weight: bold;
        color: #2c3e50;
        margin-bottom: 10px;
      }

      .price-change {
        display: flex;
        gap: 20px;

        .change-item {
          display: flex;
          flex-direction: column;

          span:first-child {
            font-size: 16px;
            color: #7f8c8d;
          }

          span:last-child {
            font-size: 14px;
            font-weight: bold;

            &.positive {
              color: #2ecc71;
            }

            &.negative {
              color: #e74c3c;
            }
          }
        }
      }
    }

    .trend-chart {
      height: 60px;
      margin-bottom: 20px;
    }

    .update-time {
      font-size: 18px;
      color: #95a5a6;
      text-align: right;
    }
  }
}

.header-banner {
  max-width: 1200px;
  margin: 40px auto 50px auto;
  background-image: url('../../assets/recycling/componyImages/price-backimg.png');
  background-size: cover;
  background-position: center;
  height: 220px;
  display: flex;
  align-items: center;
  // position: relative;
  border-radius: 8px;
  overflow: hidden;

  .header-overlay {
    margin-left: 40px;

    .header-overlay_title {
      font-size: 40px;
      font-weight: 400;
      letter-spacing: 0px;
    }

    .subtitle {
      font-size: 20px;
      font-weight: 400;
      letter-spacing: 0px;
    }
  }
}

.waste-buttons-container {
  padding: 20px 0;
  background-color: #f5f7fa;
  border-radius: 4px;
  margin: 10px;
  display: flex;
  align-items: center;
}

.filter-title {
  margin-right: 15px;
  font-size: 20px;
  font-weight: 400;
  letter-spacing: 0px;
  color: rgba(21, 173, 97, 1);
}
.smallScreen {
  display: none;
}
.waste-button {
  padding: 4px 10px;
  font-size: 20px;
  margin: 0 5px;
  background: transparent;
  color: rgba(0, 0, 0, 1);
  cursor: pointer;
}

.waste-button_active {
  border-radius: 6px;
  background: rgba(21, 173, 97, 1);
  color: rgba(255, 255, 255, 1);
}

.recycle-price_wrapper {
  // display: flex;
  // justify-content: center;
}

:root {
  --chart-width: 320px;
  --chart-height: 100px;
}

@media screen and (max-width: 768px) {
  .header-banner {
    max-width: unset !important;
    margin: 0 !important;
    height: 150px !important;

    .header-overlay_title {
      font-size: 16px !important;
      font-weight: 600 !important;
      letter-spacing: 0px !important;
    }

    .subtitle {
      font-size: 14px !important;
      padding-top: 10px !important;
    }
  }

  .recycle-price-index {
    max-width: 100%;

    .resource-grid {
      grid-template-columns: repeat(auto-fill, minmax(48%, 1fr));
      .resource-name {
        font-size: 14px !important;
      }
      .resource-icon {
        width: 20px !important;
        height: 20px !important;
        font-size: 16px !important;
      }
      .current-price {
        font-size: 14px !important;
      }
      .change-item {
        span {
          font-size: 14px !important;
        }
      }
      .update-time {
        font-size: 12px !important;
      }
    }

    .trend-chart {
      height: 100px !important;
    }
  }

  .waste-buttons-container {
    display: flex !important;
    align-items: center !important;
    margin: 0 !important;
  }

  .filter-title {
    width: 50px !important;
    font-size: 16px !important;
  }

  .waste-button {
    display: none !important;
  }
  .smallScreen {
    width: calc(100% - 50px) !important;
    display: block !important;
  }
}
</style>
